import { Pagination } from './Pagination'
import { withPagination } from './withPagination'

const ConnectedPagination = withPagination(Pagination)

export { ConnectedPagination as Pagination }
